var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.14 132.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0c0c0c;}.cls-2{fill:#505050;}.cls-3{fill:#9ca5ad;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 66.07,
    cy: 66.07,
    r: 60.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.85,86.42,66.07,82.7,36.28,86.42a16.64,16.64,0,0,0-14.57,16.51v4.91a60.79,60.79,0,0,0,88.71,0v-4.91A16.63,16.63,0,0,0,95.85,86.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.07,87.78c-15,0-27.26-14.71-27.26-32.8,0-16.56,10.7-27.26,27.26-27.26S93.33,38.42,93.33,55C93.33,73.07,81.1,87.78,66.07,87.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.07,132.14A65.43,65.43,0,0,1,18,111.32a5.11,5.11,0,0,1-1.38-3.48v-4.91a21.76,21.76,0,0,1,19-21.55l29.79-3.72a5.31,5.31,0,0,1,1.26,0l29.78,3.72h0a21.76,21.76,0,0,1,19,21.55v4.91a5.07,5.07,0,0,1-1.39,3.48A65.39,65.39,0,0,1,66.07,132.14ZM26.8,105.77a55.7,55.7,0,0,0,78.54,0v-2.84A11.57,11.57,0,0,0,95.22,91.47L66.07,87.82,36.92,91.47A11.57,11.57,0,0,0,26.8,102.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.07,132.14a66.07,66.07,0,1,1,66.07-66.07A66.15,66.15,0,0,1,66.07,132.14Zm0-122A55.91,55.91,0,1,0,122,66.07,56,56,0,0,0,66.07,10.16Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 101.03,
    cy: 116.03,
    r: 16.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104,115.79v-7.56a3,3,0,1,0-6,0v15.61a3,3,0,1,0,6,0v-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.79,113.06H93.23a3,3,0,1,0,0,6h15.61a3,3,0,1,0,0-6h-8Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.266e3a9084aaad1c4523c201b6a8f552.svg";
export { ForwardRef as ReactComponent };